// extracted by mini-css-extract-plugin
export default {"block":"InnerBlock_block__TZJSM","header":"InnerBlock_header__qqtAt","buttons":"InnerBlock_buttons__oSgvv","bordered":"InnerBlock_bordered__DCUJ+","line2":"InnerBlock_line2__xIl9u"};